import React from "react";
import { hcExito } from "../../../../HC/hcSwal";
import SeccionCard from "../SeccionCard";
import { eliminarDiagnostico } from "../guardado";

/**
 * Diagnósticos (OBLIGATORIA). El alta usa el formulario que ya existe
 * (ModalPaciente), abierto desde aquí; el listado y la baja son inline.
 */
export default function SeccionDiagnosticos({
  diagnosticos = [],
  bloqueado,
  onAbrirModal,
  onRefrescar,
  onNavegar,
  amberFoot,
  amberMsg,
}) {
  const borrar = async (id) => {
    const r = await eliminarDiagnostico(id);
    if (r.success) {
      hcExito("Diagnóstico eliminado");
      onRefrescar();
    }
  };

  return (
    <SeccionCard
      seccionId="diagnosticos"
      headerExtra={<span className="cev__tag cev__tag--grey">{diagnosticos.length}</span>}
      onNavegar={onNavegar}
      amberFoot={amberFoot}
      amberMsg={amberMsg}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
        <button type="button" className="cev__btn cev__btn--pri cev__btn--sm" disabled={bloqueado} onClick={onAbrirModal}>
          + Agregar diagnóstico
        </button>
      </div>

      {diagnosticos.length === 0 ? (
        <div className="cev__empty">Sin diagnósticos. Esta sección es obligatoria para finalizar.</div>
      ) : (
        <table className="cev__list">
          <thead>
            <tr>
              <th>Código CIE</th>
              <th>Tipo</th>
              <th>Observaciones</th>
              <th aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {diagnosticos.map((d) => (
              <tr key={d.iddiagnostico_cita_paciente}>
                <td>{d.diagnostico?.codigo} · {d.diagnostico?.nombre}</td>
                <td style={{ textTransform: "capitalize" }}>{d.typo_diagnostico?.toLowerCase()}</td>
                <td>{d.comentario}</td>
                <td>
                  <button
                    type="button"
                    className="cev__btn cev__btn--ghost cev__btn--sm"
                    disabled={bloqueado}
                    onClick={() => borrar(d.iddiagnostico_cita_paciente)}
                    title="Eliminar diagnóstico"
                  >
                    Quitar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </SeccionCard>
  );
}
